/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PosSession } from '../../models/pos-session';

export interface PosSessionsControllerGetCurrentSession$Params {
}

export function posSessionsControllerGetCurrentSession(http: HttpClient, rootUrl: string, params?: PosSessionsControllerGetCurrentSession$Params, context?: HttpContext): Observable<StrictHttpResponse<PosSession>> {
  const rb = new RequestBuilder(rootUrl, posSessionsControllerGetCurrentSession.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PosSession>;
    })
  );
}

posSessionsControllerGetCurrentSession.PATH = '/pos/sessions/current';
